import { createAsyncThunk } from "@reduxjs/toolkit";
import { categoryService } from "@/src/services/categoryService";
import type { RootState } from "@/src/redux/types";
import { getApiErrorMessage } from "@/src/utils/helpers";

export const fetchCategoryChildrenList = createAsyncThunk(
  "baseData/fetchCategoryChildren",
  async (_, { getState, rejectWithValue }) => {
    const state = getState() as RootState;
    const { isAuthenticated, accessToken, user } = state.auth;

    if (!isAuthenticated || !accessToken || !user?.id) {
      return rejectWithValue("Sign in to load category data.");
    }

    try {
      const categoryChildren = await categoryService.listAllChildren();
      return {
        categoryChildren,
        userId: user.id,
      };
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error));
    }
  },
);
